import React from "react";
import { StyleSheet } from "react-native";
import Text from "@components/ds/DsText";
import { tokens, sharedStyles } from "@components/ds/tokens";

// TP context card on the scan screens (spec p2 frames 3-4) — a white
// rounded, bordered card with the bold title and, on the same line in
// smaller grey text, the meta ("TP - <id> · N शिपमेंट · <area>"). Nested
// <Text> so the two styles flow as one paragraph and wrap together.

const TpSummaryCard = ({ titleText, metaText, testID }) => (
  <Text variant="title_16" style={styles.card} testID={testID}>
    {titleText}
    {"  "}
    <Text variant="caption_2" style={styles.meta}>
      {metaText}
    </Text>
  </Text>
);

export default TpSummaryCard;

const styles = StyleSheet.create({
  card: { ...sharedStyles.card, color: tokens.textPrimary },
  meta: { color: tokens.textSecondary },
});
